//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("account", AccountFactory);

    AccountFactory.$inject = ["apiClientFactory"];
    function AccountFactory(apiClientFactory) {

        const routePrefix = "api/Account/";

        return {
            MySignins: apiClientFactory.post(routePrefix + "MySignins/"),
        };
    }
})();
